import React from 'react';
import styled from 'styled-components';
import ChatInterface from './components/ChatInterface';
import PlaneGame from './components/PlaneGame';
import logo from './assets/logo_mus.svg';

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  position: relative;
  overflow-x: hidden;
  z-index: 1;
`;

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  padding-top: 20px;
  z-index: 2;
`;

const Logo = styled.img`
  height: 80px;
`;

const ChatSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  z-index: 2;
`;

const App = () => {
  return (
    <>
      <PlaneGame />
      <AppContainer>
        <Header>
          <Logo src={logo} alt="MUS Logo" />
        </Header>
        <ChatSection>
          <ChatInterface />
        </ChatSection>
      </AppContainer>
    </>
  );
};

export default App;
